import { render, staticRenderFns } from "./PromisedActivated.vue?vue&type=template&id=6446e5eb&scoped=true&"
import script from "./PromisedActivated.vue?vue&type=script&lang=js&"
export * from "./PromisedActivated.vue?vue&type=script&lang=js&"
import style0 from "./PromisedActivated.vue?vue&type=style&index=0&id=6446e5eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6446e5eb",
  null
  
)

export default component.exports